import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import utils from './utils';
import { datepickerClass } from './styles';
import { getLocale } from '../locale';

var Quick =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Quick, _React$Component);

  var _super = _createSuper2(Quick);

  function Quick() {
    _classCallCheck(this, Quick);

    return _super.apply(this, arguments);
  }

  _createClass(Quick, [{
    key: "getOptions",
    value: function getOptions() {
      var timeZone = this.props.timeZone;
      return {
        timeZone: timeZone,
        startOfWeek: getLocale('startOfWeek')
      };
    }
  }, {
    key: "compareDate",
    value: function compareDate(a, b) {
      var type = this.props.type;
      return utils.compareDateArray(a, b, type, this.getOptions());
    }
  }, {
    key: "handleQuick",
    value: function handleQuick(quick) {
      if (quick.invalid) {
        console.error("the date you provider for ".concat(quick.name, " is invalid, please check the date in quickSelect!"));
        return;
      }

      var onChange = this.props.onChange;
      if (onChange) onChange(quick);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          quicks = _this$props.quicks,
          current = _this$props.current,
          children = _this$props.children;
      var currentArray = Array.isArray(current) ? current : [current];
      if (!quicks) return children || null;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: datepickerClass('quick-select')
        }, quicks.map(function (q, i) {
          return (
            /*#__PURE__*/
            React.createElement("div", {
              onClick: _this.handleQuick.bind(_this, q),
              className: datepickerClass('quick-select-item', _this.compareDate(q.value, currentArray) && 'quick-select-item-active'),
              key: i
            }, q.name)
          );
        }))
      );
    }
  }]);

  return Quick;
}(React.Component);

export { Quick as default };